export const datesTypes = {rest:"Отдых", entertainment:"Развлечения", sport:"Спорт", extrim:"Экстрим", travel:"Путешествия", relax:"Релакс"}

export const datesInitialTypes = ["mine", "visited", "liked"]